module.exports = __webpack_public_path__ + "img/abi-vertical.cf0c8406.png";